<template>
  <div class="row attachments-files">

    <div class="row">
      <div class="row message-upload" v-if="message != ''">
        <div :class="typeMessage" role="alert">
          {{message}}
        </div>          
      </div>    
    </div>

    <div class="d-flex align-items-center" v-if="loading">
      <p class="myLabel" for="observations">Subiendo...</p>
      <div class="progress">
        <div class="progress-bar progress-bar-striped bg-warning" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>  

    <div class="upload-multiple-file" v-else>
      <div class="col-sm-12 attachs-content">

        <div class="col-sm-12">

          <div class="col-sm-3 icon-upload">
            <label :for="`file_${type_document_academic}`" id="label-upload">
              <img :src="img" alt="" class="img-upload">              
            </label>          
            <b-button class="button-save button-form-steps save-academic">Sube aqui tus {{textSection}}</b-button>
            <input type="file" class="input-upload" :id="`file_${type_document_academic}`" :ref="`files_${type_document_academic}`" multiple v-on:change="handleFilesUpload()">
          </div>  
          <div class="col-sm-9">
            <p class="myLabel">{{textSection}}</p>
            <ul>
              <li v-for="document in propmessage" :key="document">
                <p class="myLabel">{{document}}</p>
              </li>
            </ul>
            <p class="myLabel">Puedes subirlos en lote o uno por uno</p>
            <p id="uploadInstruction">Archivos permitidos: PDF, DOC, DOCX, Imágenes, etc.</p>
          </div>                    
        </div>
        <div class="col-sm-12" v-if="academicReferenceArchives != null && viewFiles">
          <p class="myLabel">Archivos subidos: {{academicReferenceArchives.filter(archives => archives.type_document_academic == type_document_academic).length}}</p>
          <ul v-if="academicReferenceArchives.length > 0">
            <li v-for="archive in academicReferenceArchives.filter(archives => archives.type_document_academic == type_document_academic)" :key="archive.id">
              <template v-if="archive != null">
                <a
                  :href="normalizeSecureFileUrl(archive.url)"
                  class="myLabel"
                  target="_blank"
                  @click.prevent="openSecureFileUrl(archive.url, { resourceType: 'project_archive', id: archive.id })"
                >{{archive.name.substring(0,40)}}</a>
                <button @click.prevent="deleteArchive(archive.id)" type="button" class="buttonDeleteFile"><i class="far fa-trash-alt"></i></button>
              </template>
            </li>
          </ul>          
        </div>              
      </div>
    </div>                  

  </div>
</template>

<script>
  import axios from 'axios'
  import { eventBus } from './../../application'
  import secureFiles from '../../mixins/secureFiles'
  export default {
    mixins: [secureFiles],
    props: ['project', 'academic_reference', 'propmessage', 'academicReferenceArchives', 'type_document_academic', 'img', 'textSection','viewFiles'],
    data(){
      return {
        loading: false,
        typeMessage: '',
        message: '',        
        files: ''
      }
    },
    methods: {
      setHeaders () {
        const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
        axios.defaults.headers["x-csrf-token"] = token
        axios.defaults.headers.common["Content-Type"] = "multipart/form-data"        
        axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
      },      
      async submitFiles(){
        this.loading = true
        this.setHeaders()

        let formData = new FormData();
        for( var i = 0; i < this.files.length; i++ ){
          let file = this.files[i];
          formData.append('files[' + i + ']', file);
        }
        let request = null

        if (this.academic_reference.id === undefined){
          request = await axios.put( `/upload_multiple_files_of_project?project_id=${this.project.id}&type_document_academic=${this.type_document_academic}`, formData)
          this.renderResult(request)
        }else{
          request = await axios.put( `/upload_multiple_files_of_project?project_id=${this.project.id}&academic_reference_id=${this.academic_reference.id}&type_document_academic=${this.type_document_academic}`, formData)
          this.$emit('update-files')
          this.renderResult(request)
        }

      },
      renderResult (request) {
        this.loading = false
        if (request.status == 200){
          this.showMessage(`${request.data.count_archives_save} archivo(s) subido(s) con éxito`, 'alert-success', 7000)
          eventBus.$emit('updateArchives', { archives: request.data.project_archives})
        } else {
          this.showMessage('No se pudieron guardar los archivos', 'alert-danger', 7000)
        }
      },
      handleFilesUpload(){
        this.files = this.$refs[`files_${this.type_document_academic}`].files;
        this.submitFiles()
      },
      showMessage(message, typeMessage, time){
        this.message = message
        this.typeMessage = `alert ${typeMessage}`
        setTimeout(() => this.message = '', time)
      },
      async deleteArchive(archiveId) {
        this.setHeaders()
        let request = await axios.delete( `/delete_file_of_project?archive_id=${archiveId}`)
        if (request.status == 200) {
          this.showMessage(`Archivo eliminado con éxito`, 'alert-success', 7000)
          if (this.academic_reference != null) {
            eventBus.$emit('updateArchives', { archives: request.data.project_archives.filter(archive => archive.academic_reference_id == this.academic_reference.id )})
          } else {
            eventBus.$emit('updateArchives', { archives: request.data.project_archives})
          }
        }        
      }
    }
  }
</script>